import React, { Component } from 'react';
import { Grid, Button } from "@material-ui/core";
import {
    Menu,
    Close,
    FindInPage,
    Delete,
} from '@material-ui/icons';
import { getMerchants } from '../../../logic/APIHandler';
import { filterDataTwoConditions } from '../../../logic/Handler';

import Sidebar from '../../../components/Sidebar_Com';
import TableV2 from '../../../components/Table_Com_V2';
import StatusModal from '../../../components/Modal_Com';
import Spinner from '../../../components/Loading_Com';

class Merchant extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            open: false,
            openJWT: false,
            merchantId: "00000000",
            merchantName: '',
            isLoading: false,
            isSidebarOpen: 'slide-out',
            search: localStorage.getItem('search') || '',
            totalData: 0,
            params: null,
        }
        this.windowWidth = window.innerWidth;
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    columns = [
        { 
            title: "Nama Usaha", 
            field: "name",
            tooltip: "Nama Usaha",
            width: 120,
        },
        { 
            title: "Nama Pemilik", 
            field: "applier_name",
            tooltip: "Nama Pemilik Usaha",
            width: 130,
        },
        { 
            title: "Nomor Kontak", 
            field: "phone_number",
            tooltip: "Nomor Kontak Pemilik Usaha",
            width: 140,
        },
        { 
            title: "Email", 
            field: "email",
            tooltip: "Email Pemilik Usaha",
        },
        { 
            title: "Status", 
            field: "status",
            tooltip: "Status Registrasi Merchant",
            render: rowData =>
                rowData.status === "active" ? (
                    <h5 className="status-bar-active">Active</h5>
                ) : rowData.status === "inactive" ? (
                    <h5 className="status-bar-inactive">Inactive</h5>
                ) : (
                    <h5  className="status-bar-registered">Registered</h5>
                )
        },
    ];

    actions = [
        {
            icon: () => <FindInPage />,
            tooltip: "Lihat Detail Merchant",
            onClick: (_, rowData) => {
                this.props.history.push({
                    pathname: "/merchant-benefit-detail/" + rowData._id,
                });
            },
        },
        {
            icon: () => <Delete />,
            tooltip: "Hapus Merchant",
            onClick: (_, rowData) => {
                this.handleOpen(rowData);
            },
        },
    ];

    // Show delete merchant modal
    handleOpen(merchant) {
        this.setState({
            open: true,
            merchantId: merchant._id,
            merchantName: merchant.name,
        })
    }

    // CLose merchant modal
    handleClose() {
        this.setState({
            open: false,
        })
    }

    // Toggle sidebar menu in responsive
    toggleSidebar() {
        if ( this.state.isSidebarOpen === 'slide-out' ) {
            this.setState({
                isSidebarOpen: 'slide-in',
            });
        }
        else {
            this.setState({
                isSidebarOpen: 'slide-out',
            });
        }
    }

    // Get data for table
    async getData(params) {
        this.setState({ isLoading: true });
        const page = this.props.match.params ? (Number(this.props.match.params.page) + 1) : 1;
        const payload = {
            page: params && params.page ? params.page :  page,
            sortBy: params && params.sortBy ? params.sortBy : localStorage.getItem('sortBy') ? localStorage.getItem('sortBy') : 'created_at',
            sort: params && params.sort ? params.sort : localStorage.getItem('sort') ? localStorage.getItem('sort') :  'asc',
            status: 'active',
            ...this.state.search && { search: this.state.search },
        };

        this.setState({ params: payload });
        localStorage.setItem('sortBy', payload.sortBy);
        localStorage.setItem('sort', payload.sort);

        let merchants = await getMerchants(payload, false);
        if ( merchants[0] && merchants[0].status === 200 ) {
            // let result = await filterDataTwoConditions(merchants[0].data, "status", "active", "inactive");
            const result = merchants[0].data.datas;
            this.setState({
                data: result,
                totalData: merchants[0].data.total,
                isLoading: false,
            });
        }
        else if ( merchants[1] && merchants[1].status === 401) {
            this.setState({
                openJWT: true,
                isLoading: false,
            });
        }
        else {
            this.setState({ isLoading: false });
        }
    };

    componentDidMount() {
        this.getData();
    };

    componentDidUpdate(_, prevState) {
        setTimeout(() => {
            if (this.state.search.length > 0 && (
              this.state.search.substring(0, this.state.search.length - 1) === prevState.search || prevState.search.substring(0, prevState.search.length - 1) === this.state.search
            )) {
                const search = this.state.search.toLowerCase();
                localStorage.setItem('search', search);
                this.props.history.push({ pathname: '/merchant-benefit/0' });
                this.getData({ search: '', page: 1 });
            } else if (this.state.search.length === 0 && prevState.search) {
                this.props.history.push({ pathname: '/merchant-benefit/0' });
                this.getData({ search: '', page: 1 });
            }
        }, 700);
    };

    render() {
        return (
            <div className="content">
                { this.state.isLoading ? ( <Spinner /> ) : "" }
                <Sidebar sidebarState={(this.windowWidth < 768)? this.state.isSidebarOpen : ""} />
                
                <StatusModal
                    open={this.state.open}
                    onClose={this.handleClose}
                    onClickCancel={this.handleClose}
                    modalType="merchant"
                    id={this.state.merchantId}
                    color="primary"
                    modalTitle="Hapus Merchant?"
                    dataName={this.state.merchantName}
                    submitText="Delete"
                    cancelText="Cancel"
                    successText="Berhasil menghapus merchant!"
                    errorText="Gagal menghapus merchant!"
                />
                <StatusModal
                    open={this.state.openJWT}
                    modalType="handle-jwt"
                    modalTitle="Token Anda Sudah Expire"
                />

                <Grid container className="responsive-header">
                    <Grid item xs={6}>
                        <h2>IDEPRENEURS</h2>
                    </Grid>
                    <Grid item xs={6} className="menu-icon-btn">
                        <Button variant="outlined" onClick={this.toggleSidebar}>
                            {this.state.isSidebarOpen === 'slide-out'? <Menu /> : <Close />}
                        </Button>
                    </Grid>
                </Grid>

                <Grid container className="grid-container">
                    <TableV2
                        title="Tabel Merchant"
                        path="/merchant-benefit"
                        columns={this.columns}
                        actions={this.actions}
                        data={this.state.data}
                        total={this.state.totalData}
                        search={this.state.search}
                        setSearch={val => this.setState({ search: val })}
                        refetchTableData={params => this.getData(params)}
                        params={this.state.params}
                    />
                </Grid>
            </div>
        );
    }
}

export default Merchant;